import { Box, Divider, IconButton, Paper, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import { loadTextFromFile } from "../../../../../utils/loadTextFromFile";

export default function Service({ service }) {
  const [showServiceDetails, setShowServiceDetails] = useState(false);
  const [serviceDetailsHeight, setServiceDetailsHeight] = useState("0px");
  const serviceDetailsContainerRef = useRef(null);

  const [serviceDescription, setServiceDescription] = useState("");
  const [error, setError] = useState(null);

  useEffect(
    function () {
      if (showServiceDetails) {
        setServiceDetailsHeight(
          `${serviceDetailsContainerRef.current.scrollHeight}px`,
        );
      } else {
        setServiceDetailsHeight("0px");
      }
    },
    [showServiceDetails],
  );

  useEffect(
    function () {
      loadTextFromFile({ fileName: service.description , dir: 'servicesDescriptions'})
        .then((txt) => {
          setServiceDescription(txt);
          setError(null);
        })
        .catch((e) => {
          setError(e);
          setServiceDescription("");
        });
    },
    [service.description],
  );

  return (
    <Paper
      sx={{
        m: 3,
        width: 1000,
      }}
    >
      <Box
        sx={{
          textAlign: "left",
          display: "flex",
          alignItems: "center",
          ml: 3,
        }}
      >
        <Typography variant="h5">{service.title}</Typography>
        <IconButton onClick={() => setShowServiceDetails(!showServiceDetails)}>
          {showServiceDetails ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>
      <Divider />
      <Box
        sx={{
          height: serviceDetailsHeight,
          overflow: "hidden",
          transition: "height 0.5s ease",
          textAlign: "left",
        }}
      >
        <div ref={serviceDetailsContainerRef}>
          {service.subtitle && (
            <Typography sx={{ textAlign: "left", p: 1 }} variant="h6">
              {service.subtitle}
            </Typography>
          )}
          <Typography
            sx={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              textAlign: "left",
              p: 1,
            }}
          >
            {serviceDescription}
          </Typography>
          {error && <Typography color="error">{error.message}</Typography>}
        </div>
      </Box>
    </Paper>
  );
}
